import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'

@Injectable({providedIn: 'root'})
export class ContribuicoesProvider {

  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;

  constructor(
    public http: HttpClient,
  ) {

  }

  getContasBancarias() {
    return this.http.get<any>(this.baseUrl + '/contribuicao/get-contas-bancarias').pipe(map(data => {
      return data;
    }));
  }

  getConfigs() {
    return this.http.get<any>(this.baseUrl + '/contribuicao/get-configs').pipe(map(data => {
      return data;
    }));
  }

  getMinhasContribuicoes() {
    return this.http.get<any>(this.baseUrl + '/contribuicao/get-minhas-contribuicoes').pipe(map(data => {
      return data;
    }));
  }

  getBoletoParcela(idContaReceberParcela: any) {
    return this.http.post<any>(this.baseUrl + '/contribuicao/criar-boleto-parcela', { idContaReceberParcela: idContaReceberParcela }).pipe(map(data => {
      return data;
    }));
  }

  cancelarPlanoContribuicao(idPlanoContribuicaoPessoa: any) {
    return this.http.post<any>(this.baseUrl + '/contribuicao/cancelar-contribuicao', { idPlanoContribuicaoPessoa: idPlanoContribuicaoPessoa }).pipe(map(data => {
      return data;
    }));
  }

  registrarTokenTemporario() {
    return this.http.get<any>(this.baseUrl + '/contribuicao/registrar-token').pipe(map(data => {
      return data;
    }));
  }

  getCartoesPessoa() {
    return this.http.get<any>(this.baseUrl + '/iugu-cartao-pessoa/get-cartoes-pessoa').pipe(map(data => {
      return data;
    }));
  }

  alterarCartaoPessoa(payment_id: any) {
    return this.http.post<any>(this.baseUrl + '/iugu-cartao-pessoa/alterar-cartao-pessoa', { payment_id: payment_id }).pipe(map(data => {
      return data;
    }));
  }


}
